import { render, staticRenderFns } from "./text_config.vue?vue&type=template&id=c22c63ac&"
import script from "./text_config.vue?vue&type=script&lang=js&"
export * from "./text_config.vue?vue&type=script&lang=js&"
import style0 from "./text_config.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports